import { useEffect, useState } from 'react'
import { GeoJSON, useMap } from 'react-leaflet'
import L from 'leaflet'
import MapBase from './MapBase'
import { cartePrixDVF } from '@/api/geo'

function FitGeoJSON({ geojson }) {
  const map = useMap()
  useEffect(() => {
    if (!geojson?.features?.length) return
    const bounds = L.geoJSON(geojson).getBounds()
    if (bounds.isValid()) map.fitBounds(bounds, { padding: [20, 20] })
  }, [geojson, map])
  return null
}

export default function MapDVF({ latitude, longitude, codeInsee, typeBien }) {
  const [data, setData] = useState(null)

  useEffect(() => {
    if (!codeInsee) return
    cartePrixDVF({ code_insee: codeInsee, type_bien: typeBien || '' })
      .then(setData)
      .catch(() => setData(null))
  }, [codeInsee, typeBien])

  const style = (feature) => ({
    fillColor: feature.properties?.color || '#ccc',
    weight: 1,
    opacity: 0.8,
    color: '#666',
    fillOpacity: 0.6,
  })

  const onEachFeature = (feature, layer) => {
    const p = feature.properties
    if (!p?.prix_median) return
    const sectionId = (p.id || '').slice(-2)
    layer.bindTooltip(
      `<b>Section ${sectionId}</b><br/>` +
      `${Math.round(p.prix_median).toLocaleString('fr-FR')} €/m²<br/>` +
      `${p.nb_transactions || '?'} transaction(s)`,
      { sticky: true },
    )
  }

  if (!data?.geojson) return null

  return (
    <div>
      <MapBase latitude={latitude} longitude={longitude} zoom={13} height="400px" scrollWheelZoom={false}>
        <GeoJSON
          key={`${codeInsee}-${typeBien}`}
          data={data.geojson}
          style={style}
          onEachFeature={onEachFeature}
        />
        <FitGeoJSON geojson={data.geojson} />
      </MapBase>

      {data.legend && (
        <div className="flex items-center gap-2 mt-2 text-xs text-slate-600">
          <span>{data.legend.min?.toLocaleString('fr-FR')} €</span>
          <div
            className="flex-1 h-3 rounded"
            style={{ background: 'linear-gradient(to right, rgb(0,200,50), rgb(255,200,50), rgb(255,0,50))' }}
          />
          <span>{data.legend.max?.toLocaleString('fr-FR')} €</span>
        </div>
      )}
    </div>
  )
}
